import React from "react";
interface LoaderProps {
  classes?: string;
  color?:string;
}

const Loader: React.FC<LoaderProps> = ({color}) => {
  return (
      <div className={`loader ${color ?color:"bg-[#fcfbfa]"}`}></div>
  );
};

export default Loader;
